import React, {useState} from 'react';
import { InputWithInnerLabel } from 'src/components/ui/inputFields/input-with-label';
import { huaweiLogin,huaweiStationList,addHuaweiServer,editHuaweiServer } from 'src/api/servers/huawei';
import { set } from 'react-hook-form';
import Cookies from 'js-cookie';
import LoadingContainer from 'src/components/ui/loading/loading-container';
import { SetupHuaweiDeviceInfo,SetupHuaweiDeviceFields } from '.';
import { SetupDeviceLocation } from '../influx/setupDeviceInfo';
import { useGetHuaweiDeviceList } from 'src/api/devices';
// import { useDeviceManagement } from "src/context/stores";
// import { shallow } from "zustand/shallow";
import { useTranslation } from 'react-i18next'

//TODO: to refactor and use global state management library for the states
const SetupHuaweiDevice = ({step,setStep, type, setDeviceDetails,deviceDetails, handleOnClose, isEditDevice, plantId, plantLocation,deviceId}) => {
    const { t } = useTranslation("settings");

    const {huaweiDeviceList, isLoadingHuaweiDeviceList, isErrorHuaweiDeviceList} = useGetHuaweiDeviceList(plantId)
      
    return ( 
        <>
            {(step >1 ) &&
            <LoadingContainer
                hasData={huaweiDeviceList?.length > 0}
                isError={isErrorHuaweiDeviceList}
                loadingText={`${t('device_management.loading.loading_huawei')}...`}
                errorText={`${t('device_management.loading.error_huawei')}`}
                isLoading={isLoadingHuaweiDeviceList}
            >
                {/* <SetupHuaweiLogin step={step} setStep={setStep} setDeviceDetails={setDeviceDetails} setHuaweiDeviceList={setHuaweiDeviceList} deviceDetails={deviceDetails} plantId={plantId}/> */}
                <SetupHuaweiDeviceInfo step={step} setStep={setStep}  huaweiDeviceList={huaweiDeviceList}/>
                <SetupHuaweiDeviceFields step={step} setStep={setStep} setDeviceDetails={setDeviceDetails} deviceDetails={deviceDetails} />
                <SetupDeviceLocation 
                        step={step} setStep={setStep} 
                        setDeviceDetails={setDeviceDetails} 
                        deviceDetails={deviceDetails} 
                        plantId={plantId} 
                        plantLocation={plantLocation}
                        setupType={type}
                        deviceId={deviceId} 
                        handleOnClose={handleOnClose}
                        isEditDevice={isEditDevice}
                        
                    />     
            </LoadingContainer>
            }           
        
        </>
       
     );
}
 
export default SetupHuaweiDevice;


   // "username": "Sakayong_P",
    // "password": "Huawei@1234"
